import moment from "moment";

export const Dates = {

	data() {
		return {
			defaultDateFormat: "YYYY-MM-DD",
			defaultDateTimeFormat: "YYYY-MM-DD HH:mm:ss",
			timestampFormat: "YYYY-MM-DD-HH-mm-ss",
			dateFormat: "YYYY-MM-DD"
		};
	},

	methods: {
		parseDateAsArray(dateString) {
			let m = moment(dateString);
			return [m.year(), m.month() - 1, m.date()];
		},

		stringsToDates(strings) {
			return strings.map(s => this.parseDateAsArray(s));
		},

		datesToStrings(dates, format = this.defaultDateTimeFormat) {
			return dates.map(d => moment(d).format(format));
		},

		displayDateTime(dateString) {
			return moment(dateString).format(this.defaultDateTimeFormat);
		},

		displayDate(dateString) {
			return moment(dateString).format(this.dateFormat);
		},

		isInPast(dateString) {
			return moment().isSameOrAfter(dateString);
		},

		isInFuture(dateString) {
			return moment().isSameOrBefore(dateString);
		},

		getFilenameTimestamp () {
			return moment().format(this.timestampFormat);
		},
		getTodayString() {
			return moment().format(this.defaultDateFormat);
		},
		getMinStringDate(dates) {
			const validDates = dates.filter(date => date !== null && date !== undefined);
			const minDate = validDates.length > 0 ? validDates.reduce((min, date) => (date < min ? date : min)) : null;
			return minDate;
		},
		getMaxStringDate(dates) {
			const validDates = dates.filter(date => date !== null && date !== undefined);
			const maxDate = validDates.length > 0 ? validDates.reduce((max, date) => (date > max ? date : max)) : null;
			return maxDate;
		}
	},

};
